const accessibilityProvider = ({ name = "" } = {}) => ({
	tabIndex: 0,
});

export default accessibilityProvider;
